import React, { useMemo } from 'react';
import { useField, useFormState } from 'react-final-form';
import styles from './ErrorFieldContainer.module.scss';

type Props = {
    isCategoryForm?: boolean;
}


const CategoryFormErrorFieldContainer = ({ isCategoryForm }: Props) => {
    const { meta: selectedMetricMeta } = useField("selectedMetric", { subscription: { touched: true, error: true } });
    const {
        input: { value: typeOfAmountValue },
    } = useField("typeOfAmount", { subscription: { value: true } });

    const { meta: monthsMeta, input: { value: monthsValue } } = useField("months", { subscription: { touched: true, error: true, value: true, visited: true } });
    const { touched } = useFormState();

    // console.log('meta of selectedMetric', meta);
    // console.log('typeOfAmountValue', typeOfAmountValue)
    const isFieldArrayTouchedOrVisited = useMemo(() => {
        // console.log('touched', touched);
        const touchedFields = Object.keys(touched).reduce((prev, curVal) => {
            if (touched[curVal]) {
                prev.push(curVal);
            }
            return prev;
        }, []);
        // const visitedFields = Object.keys(visited);

        // console.log('touchedFields', touchedFields)

        const isTouched = touchedFields.some(key => key.startsWith(`months[`));
        // const isVisited = visitedFields.some(key => key.startsWith(`months[`));

        return { isTouched };
    }, [touched]);

    // console.log("monthsValue", monthsValue, monthsMeta);


    return (
        <div className={styles.errorContainer}>
            {isCategoryForm && selectedMetricMeta.touched && selectedMetricMeta.error ?
                <div className={styles.errorMessage}>
                    {selectedMetricMeta.error}
                </div>
                :
                isFieldArrayTouchedOrVisited.isTouched && monthsMeta.error && monthsMeta.error.length > 0 && <div className={styles.errorMessage}>{monthsMeta.error[0]['value']}</div>}

        </div>
    )
}

export default CategoryFormErrorFieldContainer